export { SparklinesModule } from './sparklinesModule.mjs';
